import { Trans } from '@lingui/macro'
import { Box, FormLabel } from '@mui/material'
import { useFormikContext } from 'formik'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import { ResourcesDetailsButton, ResourcesDetailsLightButton } from '../resources/ResourcesDetailsCard/Button'
import { FirstLoginFlowFormikProps } from './index'
import { InfoBanner } from './InfoBanner'
import { JobDialog } from './JobDialog'
import OrganizationLine from './OrganizationLine'

export const OrganizationConnectTooManyResults = () => {
  const { enqueueSnackbar } = useSnackbar()

  const [displayJobDialog, setDisplayJobDialog] = useState(false)

  const user = useSelector((state: RootStateOrAny) => state.user)

  const {
    values, handleChange, handleBlur, setFieldValue, validateForm, setFieldError
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const onClickModifySearch = () => {
    setFieldValue('results', null)
    setFieldValue('selectedOrganizationId', null)
    setFieldValue('resultsError', '')
  }

  const onClickCreateNewOrganization = () => {
    // setFieldValue('results', null)
    setFieldValue('displayOrganizationConnectDialog', false)
    setFieldValue('displayCreateNewOrganizationDialog', true)
    setFieldValue('resultsError', '')
    setFieldValue('organization.name', values.search)
  }


  return (
    <>
      <JobDialog display={displayJobDialog} setDisplay={setDisplayJobDialog} />

      <FormLabel sx={{ textAlign: 'center', fontSize: '24px', lineHeight: '28px', mb: '54px', mt: '-32px' }}>
        <Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <FormLabel sx={{ mb: '14px' }}>
        <Trans>FIRST_LOGIN_FLOW_FIND_YOUR_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <InfoBanner
        title={<Trans>FIRST_LOGIN_FLOW_CONNECT_RATHER_CREATE_ORGANIZATION_BANNER_TITLE</Trans>}
        description={<Trans>YOU CAN CONNECT YOUR {user?.displayName} USER ACCOUNT TO MULTIPLE ORGANIZATIONS</Trans>}
      />

      <OrganizationLine
        sx={{ mt: '14px' }}
        text={<Trans>FIRST_LOGIN_FLOW_TOO_MANY_RESULTS_LABEL</Trans>}
      />

      <Box sx={{ display: 'flex', gap: '16px', mt: '16px' }}>
        <ResourcesDetailsButton
          text={<Trans>FIRST_LOGIN_FLOW_CREATE_NEW_ORGANIZATION_BUTTON</Trans>}
          onClick={onClickCreateNewOrganization}
          sx={{ width: '100%' }}
        />
        <ResourcesDetailsLightButton
          text={<Trans>FIRST_LOGIN_FLOW_MODIFY_SEARCH_BUTTON</Trans>}
          onClick={onClickModifySearch}
        />
      </Box>
    </>
  )
}
